"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const String_1 = require("helpers/String");
class ModuleUtil {
    filterByName(modules, search) {
        const normalizedSearch = (0, String_1.normalizeIgnoreCase)(search);
        if (!normalizedSearch) {
            return modules;
        }
        return modules.filter((module) => {
            return (0, String_1.normalizeIgnoreCase)(module.name).includes(normalizedSearch);
        });
    }
    getTotalSelectedItems(selectedModules, selectedPages, modules) {
        let totalItemsSelected = 0;
        selectedModules.forEach((selectedModuleItemId) => {
            const module = modules.find((item) => item.id === selectedModuleItemId);
            if (module) {
                totalItemsSelected += Number(module.totalPages);
            }
        });
        selectedPages.forEach((selectedPageItem) => {
            const hasPageLoadedInModule = modules.some((item) => {
                var _a;
                return !selectedModules.includes(item.id) &&
                    ((_a = item.pages) === null || _a === void 0 ? void 0 : _a.some((pageItem) => pageItem.id === selectedPageItem));
            });
            if (hasPageLoadedInModule) {
                totalItemsSelected += 1;
            }
        });
        return totalItemsSelected;
    }
}
exports.default = new ModuleUtil();
